import React from 'react'
import { Outlet } from 'react-router-dom'

const GrievanceRedressal = () => {
  return (
    <>
    <div>
        <Outlet />
    </div>
    </>
  )
}

export default GrievanceRedressal